import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
    const [user, setUser] = useState(() => {
        try {
            const raw = localStorage.getItem("fiscoai_user");
            return raw ? JSON.parse(raw) : null;
        } catch { return null; }
    });
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const token = localStorage.getItem("fiscoai_token");
        if (!token) { setLoading(false); return; }
        api.get("/auth/me").then((r) => {
            setUser(r.data);
            localStorage.setItem("fiscoai_user", JSON.stringify(r.data));
        }).catch(() => {
            localStorage.removeItem("fiscoai_token");
            localStorage.removeItem("fiscoai_user");
            setUser(null);
        }).finally(() => setLoading(false));
    }, []);

    const login = useCallback(async (email, password) => {
        const r = await api.post("/auth/login", { email, password });
        localStorage.setItem("fiscoai_token", r.data.token);
        localStorage.setItem("fiscoai_user", JSON.stringify(r.data.user));
        setUser(r.data.user);
        return r.data.user;
    }, []);

    const register = useCallback(async (email, password, full_name) => {
        const r = await api.post("/auth/register", { email, password, full_name });
        localStorage.setItem("fiscoai_token", r.data.token);
        localStorage.setItem("fiscoai_user", JSON.stringify(r.data.user));
        setUser(r.data.user);
        return r.data.user;
    }, []);

    const logout = useCallback(() => {
        localStorage.removeItem("fiscoai_token");
        localStorage.removeItem("fiscoai_user");
        setUser(null);
    }, []);

    const refreshUser = useCallback(async () => {
        const r = await api.get("/auth/me");
        setUser(r.data);
        localStorage.setItem("fiscoai_user", JSON.stringify(r.data));
        return r.data;
    }, []);

    return (
        <AuthContext.Provider value={{ user, loading, login, register, logout, refreshUser, setUser }}>
            {children}
        </AuthContext.Provider>
    );
}

export const useAuth = () => useContext(AuthContext);
